import React, { useContext } from 'react';
import { Navigate } from 'react-router-dom';
import { AuthContext } from '../../context/AuthContext';

/**
 * 로그인이 필요한 페이지를 보호하는 라우트 컴포넌트
 * @param {Object} props
 * @param {React.ReactNode} props.children - 보호할 페이지 컴포넌트
 * @param {boolean} props.requireAdmin - 관리자 권한 필요 여부
 */
const ProtectedRoute = ({ children, requireAdmin = false }) => {
  const { loading, isAuthenticated, isAdmin } = useContext(AuthContext);

  // 로딩 중일 때는 로딩 화면 표시
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-ivory">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-charcoal mx-auto mb-4"></div>
          <p className="text-gray-600">로딩 중...</p>
        </div>
      </div>
    );
  }

  // 로그인이 필요한데 로그인하지 않은 경우
  if (!isAuthenticated()) {
    // 관리자 페이지는 관리자 로그인으로, 일반 페이지는 일반 로그인으로
    return <Navigate to={requireAdmin ? "/admin/login" : "/login"} replace />;
  }

  // 관리자 권한이 필요한데 일반 사용자인 경우
  if (requireAdmin && !isAdmin()) {
    return <Navigate to="/" replace />;
  }

  return children;
};

export default ProtectedRoute;
